import PropTypes from 'prop-types';
import React from 'react';
import Config from '../../app.config';

function HeroButton(props) {
  const { foundingMembership } = props;
  const { pathname } = window.location;
  return (
    <div className="hero__btn">
      {foundingMembership ? (
        <a
          aria-label="phase-3-location"
          href={!pathname.includes('sweeps') && '#phase-3'}
        >
          <button
            type="button"
            className="btn-icon js-btn-hero"
            id="btnHeroScroll"
            aria-label="learn-more"
          >
            <img
              alt="learnmoreimg"
              src={`${Config.awsCloudFrontUrl}/images/phase-3/learnmore.png`}
              className="learnmoreimg"
            />
          </button>
        </a>
      ) : (
        <a aria-label="meet-squeeze-discover" href="/#Meetsqueeze">
          <button
            type="button"
            className="btn-icon js-btn-hero"
            id="btnHeroScroll"
            aria-label="discover"
          >
            <img
              src={`${Config.awsCloudFrontUrl}/images/discover.png`}
              height="164px"
              width="118px"
              className="discover"
              alt="discover"
            />
          </button>
        </a>
      )}
    </div>
  );
}

HeroButton.propTypes = {
  foundingMembership: PropTypes.bool,
};

export default HeroButton;
